/**
 * Initialize fixed list for Hosts section
 */

var ScrollMagic = require('scrollmagic')
var TweenMax = require('gsap').TweenMax
var ScrollToPlugin = require('gsap/ScrollToPlugin')
require('scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators')

module.exports = function () {
  function doObjectsCollide (a, b) {
    var aTop = a.offset().top
    var aLeft = a.offset().left
    var bTop = b.offset().top
    var bLeft = b.offset().left

    return !(
      ((aTop + a.height()) < (bTop)) ||
      (aTop > (bTop + b.height())) ||
      ((aLeft + a.width()) < bLeft) ||
      (aLeft > (bLeft + b.width()))
    )
  }

  if (window.matchMedia('(min-width: 769px)').matches) {
    var controller = new ScrollMagic.Controller()

    controller.scrollTo(function (target) {
      TweenMax.to(window, 0.5, {
        scrollTo: {
          y: target,
          autoKill: true
        },
        ease: Cubic.easeInOut
      })
    })

    var tab1Offset = $('#tab-1 .host__content').last().height()
    var tab1Fixed = new ScrollMagic.Scene({
      triggerElement: '#tab-1 .host__date-title',
      offset: 150,
      reverse: true
    })
      .setPin('#tab-1 .hosts__wrap')
      .addTo(controller)

    var menu1 = $('#tab-1 .hosts__wrap')
    var footer = $('.footer')

    var tab1Highlight = $('#tab-1 .host__content').each(function (index, element) {
      var height = $(this).height()
      var id = $(this).attr('id')
      var list = '#tab-1 .hosts li:nth-child(' + (index + 1) + ')'
      var href = $('#tab-1 .hosts a[href="#' + id + '"]').attr('href')

      if ('#' + id === href) {
        var scene1 = new ScrollMagic.Scene({
          triggerElement: '#tab-1 .host__wrap:nth-child(' + (index + 1) + ')'
        })
          .duration(height)
          .setClassToggle(list, 'active')
          .addTo(controller)
      }
    })

    var tab2Fixed = new ScrollMagic.Scene({
      triggerElement: '#tab-2 .host__date-title'
    })
      .setPin('#tab-2 .hosts__wrap')
      .addTo(controller)

    $('#tab-link-1').click(function (event) {
      $('#tab-2 .hosts__wrap').toggle()
      var tab2Highlight = $('#tab-2 .host__content').each(function (index, element) {
        var height = $(this).height()
        var id = $(this).attr('id')
        var list = '#tab-2 .hosts li:nth-child(' + (index + 1) + ')'
        var href = $('#tab-2 .hosts a[href="#' + id + '"]').attr('href')

        if ('#' + id === href) {
          var scene2 = new ScrollMagic.Scene({
            triggerElement: '#tab-2 .host__wrap:nth-child(' + (index + 1) + ')'
          })
            .duration(height)
            .setClassToggle(list, 'active')
            .addTo(controller)
        }
      })
    })

    $('.hosts li').on('click', 'a[href^=#]', function (e) {
      var id = $(this).attr('href')

      if ($(id).length > 0) {
        e.preventDefault()
        controller.scrollTo(id)

        if (window.history && window.history.pushState) {
          history.pushState('', document.title, id)
        }
      }
    })
  }

  function getCookie (name) {
    var re = new RegExp(name + '=([^;]+)')
    var value = re.exec(document.cookie)
    return (value != null) ? unescape(value[1]).toLowerCase() : null
  }

  var hostSelected = document.cookie.indexOf('STYXKEY_host_name_1')
  var timeSelected = document.cookie.indexOf('STYXKEY_host_time_1')

  if (hostSelected > -1) {
    var hostCookie = getCookie('STYXKEY_host_name_1')
    var hostID = hostCookie.replace(/\+/g, '-')

    $('#' + hostID + '1 select').prop('disabled', 'disabled')
    $('#' + hostID + '2 select').prop('disabled', 'disabled')
    $('#' + hostID + '1 .gform_button').prop('disabled', 'disabled')
    $('#' + hostID + '2 .gform_button').prop('disabled', 'disabled')
  }

  if (timeSelected > -1) {
    var timeCookie = getCookie('STYXKEY_host_time_1')
    var timeValue = timeCookie.replace(/\+/g, ' ')
    var timeSlotForms = $('.form__timeslot')

    timeSlotForms.each(function (index, element) {
      $(element).find('option').each(function () {
        var timeDropDown = $(this).text()

        if (timeDropDown === timeValue) {
          $(this).attr('disabled', 'disabled')
        }
      })
    })
  }

  var disableForms = $('.time-slot__host').size()

  if (disableForms === 2) {
    $('.form__timeslot select').prop('disabled', true)
    $('.form__timeslot .gform_button').prop('disabled', true)
    $('.host__booked').removeClass('hide')
    $('.form__timeslot select').css({
      cursor: 'default'
    })
  }

  $('.form__timeslot').on('submit', function (e) {
    $(e.target)
      .parents('.host__date-form')
      .next()
      .removeClass('hide')
  })

  $('.form__timeslot').each(function () {
    var firstOption = $(this).find('option:first-child').attr('disabled', 'disabled')
    var submitButton = $(this).find('.gform_button')

    if ($(firstOption).is(':selected')) {
      $(submitButton).prop('disabled', true)
    }
  })

  $('.form__timeslot select').change(function () {
    var otherOptions = $(this).find('option:not(:first-child)')

    if ($(otherOptions).is(':selected')) {
      $(this).closest('.form__timeslot')
        .find('.gform_button')
        .prop('disabled', false)
    }
  })
}
